import Vue from 'vue'
const state = {
  roda: [],
  usuarios: [],
  usuariosExportar: []
}

const mutations = {
  setRoda (state, data) {
    state.roda = data
  },
  setUsuarios (state, data) {
    state.usuarios = data
  },
  setUsuariosExportar (state, data) {
    state.usuariosExportar = data
  }
}

const actions = {
  getInscritos (context, data) {
    Vue.http.post('api/roda-inscritos', data).then(response => {
      context.commit('setUsuarios', response.body.data)
    })
  },
  getInscritosExportar (context, data) {
    Vue.http.post('api/roda-inscritos-exportar', data).then(response => {
      context.commit('setUsuariosExportar', response.body.data)
    })
  },
  getRoda (context, id) {
    Vue.http.get('api/roda/' + id).then(response => {
      context.commit('setRoda', response.data.data)
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/roda.js